export const SET_TEAM_MEMBERS = 'set-team-members';
export const SET_FETCHING_TEAM_MEMBERS = 'set-fetching-team-members';

export const setTeamMembers = members => {
  return {
    type: SET_TEAM_MEMBERS,
    members,
  };
};

export const setFetchingTeamMembers = fetching => {
  return {
    type: SET_FETCHING_TEAM_MEMBERS,
    fetching,
  };
};
